var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"learner-home"}},[(_vm.activeView === 'Learner')?_c('LearnerTableContainer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }